<template>
    <div class="card">
        <div class="card-header bg-gray">
            <h3 class="card-title"><i class="fab fa-telegram-plane mr-2"></i>{{ $t('general.enviodemensajes') }}
            </h3>
               <div class="card-tools d-flex align-items-center" v-show="mostrarminimizaraux">
                            <button type="button" id="botonmin" class="btn btn-tool ampliar-asegurado" data-card-widget="collapse" @click="minimizarpulsar" title="Minimizar">
                    <i class="fas fa-eye"></i>
                </button>

                        </div>
        </div>
        <div class="card-body">

            <!--INICIO LISTA GREMIOS-->
            <div class="row" v-if="gremios" :class="clasegremio">
                <div class="col-md-12">
                    <table class="table table-striped table-valign-middle">
                        <thead>
                            <tr>
                                <th v-for="columna in gremios.gremios.encabezado" :key="columna">{{ columna }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="filas in gremios.gremios.filas" :key="filas">
                                <td style="padding:0.3rem" v-for="fila in filas" :key="fila">
                                    <div v-if="fila.campos">
                                        <div v-for="(campo,index) in fila.campos" :key="campo">
                                            <label style="margin-bottom:0rem;vertical-align:top" class="btn active"
                                                v-if="campo.tipo == 'radio'">
                                                <input @click="seleccionarGremio(campo.valor)" class="defecto"
                                                    v-if="campo.valor == fila.campos[0].valor" type="radio"
                                                    name="opcionesGremio" :id="campo.valor" autocomplete="off" />
                                                <input @click="seleccionarGremio(campo.valor)"
                                                    :class="'prestacion'+index"
                                                    style="margin-bottom:0rem;vertical-align:top" v-else type="radio"
                                                    name="opcionesGremio" :id="campo.valor" autocomplete="off" />
                                                {{ campo.desc }}
                                            </label>
                                            <label class="btn active" v-else-if="campo.desc && campo.tipo == 'button'">
                                                <button style="font-size:0.7em" type="button"
                                                    v-if="campo.desc == 'Actualizar'"
                                                    @click="actualizarPrestacion(filas.columna1.campos[0].valor,index);"
                                                    class="btn btn-secondary">
                                                    <i class="fas fa-sync"> {{ campo.desc }}</i>
                                                </button>
                                            </label>
                                        </div>
                                    </div>
                                    <div v-if="!fila.campos">
                                        <p style="margin-bottom: 0px;" v-html="fila"></p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div><!--FIN TABLA LISTA GREMIOS-->
            <div v-if="spinner == true" class="spinners"></div>
            <div :class="spinner == true ? 'difuminado' : ''">
                <!--INICIO SELECT TIPO ENVIO-->
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="col-md-6">
                                <label for="exampleInputEmail1">{{ $t('general.tipodeenvio') }}</label><br>
                                <select @change="cargarTipoenvio()"
                                    class="custom-select form-control-sm exampleInputEmail1 select2"
                                    v-model="tipoenvioseleccionado"><!--watch tipoenvioseleccionado-->
                                    <option v-for="mensajes in tiposenvio" :key="mensajes.nombre" :value="mensajes"
                                        :title="mensajes.title" :disabled="mensajes.disabled == 1">
                                        {{ mensajes.nombre }}
                                    </option>
                                </select>
                                <div v-if="tipoenvioseleccionado && tipoenvioseleccionado.title">
                                    <p style="font-size: small;">{{ tipoenvioseleccionado.title }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> <!--FIN SELECT TIPO ENVIO-->
                <div v-if="mostrarChatBot">
                    <iframe
                    :src="chatbotUrl"
                    width="100%"
                    height="600"
                    frameborder="0"
                    />
                </div>
                <!--INICIO SECCION FORMULARIO-->
                <div class="form-group">
                    <!--INICIO CAMPOS-->
                    <div :style="estilocampos(campo.tipo, campo.saltolinea,campo.desc)"
                        v-for="campo in tipoenvioseleccionado.campos" :name="campo.desc" :class="campo.desc"
                        :key="campo.desc" :id="'form' + index">
                        <label style="display:block" :for="campo.nombre">{{ campo.desc }}</label>

                        <!--<span v-if="campo.tipo == 'select'">
                            <select @change="comprobarCampoPendiente(campo.actualizar)"
                                :class="'custom-select form-control ' + campo.nombre" v-model="campo.valor">
                                <option value="" selected hidden>Seleccione opción</option>
                                <option v-for="opcion in campo.valores" :key="opcion.valor" :value="opcion.valor"
                                    :disabled="campo.disabled == 'disabled'">{{ opcion.texto }}</option>
                            </select>
                        </span>-->
                        <span v-if="campo.tipo == 'select'">
                            <select
                                @change="comprobarCampoPendiente(campo.actualizar)"
                                :class="'custom-select form-control ' + campo.nombre"
                                v-model="campo.valor"
                                :multiple="campo.multiple"
                            >
                                <option v-if="!campo.multiple" value="" selected hidden>Seleccione opción</option>
                                <option
                                v-for="opcion in campo.valores"
                                :key="opcion.valor"
                                :value="opcion.valor"
                                :disabled="campo.disabled == 'disabled'"
                                :title="opcion.title || opcion.texto"
                                :style="{ color: opcion.color || 'inherit', backgroundColor: opcion.bgColor || '' }"
                                >
                                {{ opcion.texto }}
                                </option>
                            </select>
                        </span>

                        <span v-if="campo.tipo == 'text'">
                            <input
                                type="text"
                                v-model="campo.valor"
                                :disabled="campo.disabled == 'disabled'"
                                :class="'form-control ' + campo.nombre"
                                :placeholder="campo.placeholder || 'Escriba aqu�...'"
                            />
                        </span>

                        <span v-if="campo.tipo == 'radio'" @change="comprobarCampoPendiente(campo.actualizar)">
                            <input type="radio" v-model="campo.valor" :id="campo.desc" autocomplete="off" /><span
                                v-if="campo.tipo == radio">{{ campo.valor }}</span>&nbsp;&nbsp;
                        </span>

                        <span v-if="campo.tipo == 'checkbox'">
                            <input :true-value="1" :false-value="0"
                                :disabled="mensajes && mensajes.disabled == 'disabled'" type="checkbox"
                                :class="'custom-checkbox ' + campo.nombre" v-model="campo.valor" />

                        </span>

                        <span v-if="campo.tipo == 'img'">
                            <img :src="campo.src" style="width:150px">
                        </span>

                        <span v-if="campo.tipo == 'textarea' && campo.editor_html == '1'">
                            <Editor :id="campo.nombre" @input="sacarlongitud(campo.nombre)"
                                @keydown="onKeyDown($event, campo.valor, campo.condiciones.maxLength)"
                                editorStyle="height: 160px" :v-model="campo.valor"
                                v-if="campo.condiciones && campo.condiciones.maxLength">
                            </Editor>
                            <Editor editorStyle="height: 160px" v-model="campo.valor" v-else>
                            </Editor>
                            <label v-if="campo.condiciones && campo.condiciones.maxLength">{{
                                longitud[campo.nombre] }}/{{ campo.condiciones.maxLength }}
                                Caracteres</label>
                        </span>



                        <span v-if="campo.tipo == 'textarea' && campo.editor_html != '1'">

                            <textarea :id="campo.nombre"
                                @input="sacarlongitud(campo.nombre); campo.valor = sacarvalor(campo.nombre)"
                                @keydown="onKeyDown($event, campo.nombre, campo.condiciones.maxLength)"
                                v-model="campo.valor" :disabled="campo.disabled == 'disabled'"
                                v-if="campo.condiciones && campo.condiciones.maxLength"
                                :class="'form-control ' + campo.nombre"></textarea>

                            <textarea :id="campo.nombre" v-model="campo.valor"
                                @input="campo.valor = sacarvalor(campo.nombre)" :disabled="campo.disabled == 'disabled'"
                                v-else :class="'form-control ' + campo.nombre"></textarea>

                            <label v-if="campo.condiciones && campo.condiciones.maxLength">
                                {{ longitud[campo.nombre] }} /{{ campo.condiciones.maxLength
                                }} Caracteres
                            </label>


                        </span>

                        <span v-if="campo.tipo == 'date'">

                            <!--    <input :disabled="campo.disabled == 'disabled'" type="date" v-model="campo.valor"
                                :class="'form-control ' + campo.nombre" />-->
                            <Calendar :disabled="campo.disabled == 'disabled'" @date-select="campo.modificada = true"
                                dateFormat="dd/mm/yy" v-model="campo.valor" />

                        </span>

                        <!--INICIO SECCION DOCUMENTOS-->

                        <!--Subir un archivo nuevo-->

                        <div v-if="Object.keys(campo) == 'documentos' && campo.documentos[1]">

                            <Button @load="prueba123(campo)" @click="cargardocumentos()" type="button"
                                class="btn btn-info">{{
                                $t('general.documentos') }}</button>
                            <br>

                            <Dialog v-show="mostrardialogo" header="Documentos" v-model:visible="mostrardialogo" modal
                                :style="{ width: '80vw' }">
                                <div style="display: grid; gap: 20px;">
                                    <div v-for="visita in documentos" :key="visita.id_visita">
                                        <!--  <h4 v-if="visita.operario ==''">Archivos del servicio</h4>-->
                                        <h4 v-if="visita.operario !=''">{{ visita.fecha }} - {{ visita.operario }}</h4>
                                        <div v-if="visita.operario !=''" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px;">
                                            <div v-for="documento in visita.documentos" :key="documento.id_documento"
                                                style="margin-left:40px;display: flex; flex-direction: column; align-items: center; justify-content: space-between; height: 220px;">
                                                <select
                                                    :disabled="idsdocsanyadidos.includes(documento.id_documento)" @change="asociardocumento(documento);"
                                                    :class="'custom-select form-control ' + campo.documentos[0].nombre"
                                                    v-model="documento.valor" style="width: fit-content; height: 30px;">
                                                    <option :value="documento.valor" disabled selected hidden>
                                                        Seleccione</option>
                                                    <option v-for="opcion in campo.documentos[0].valores"
                                                        :key="opcion.valor" :value="opcion.valor">
                                                        {{ opcion.texto }}
                                                    </option>
                                                </select>
                                                <div v-if="documento.cuando">
                                                    <span style="width: 150px;" v-if="documento.cuando == 'despues'"
                                                        class="badge bg-blue">después</span>
                                                    <span style="width: 150px;" v-else class="badge bg-blue">{{
                                                        documento.cuando }}</span>
                                                </div>
                                                <div v-if="documento.documento.substring(documento.documento.length - 3) == 'jpg' || documento.documento.substr(documento.documento.length - 3) == 'png' || documento.documento.substr(documento.documento.length - 4) == 'jpeg' || documento.documento.substr(documento.documento.length - 3) == 'bmp' || documento.documento.substr(documento.documento.length - 3) == 'gif' || documento.documento.substr(documento.documento.length - 4) == 'tiff' || documento.documento.substr(documento.documento.length - 4) == 'webp'">

                                                </div>
                                                <div style="width: fit-content; margin-top: 5px" v-else>
                                                    <span>{{ documento.descripcion }}</span>
                                                </div>
                                                <div v-if="documento.documento.substring(documento.documento.length - 3) == 'jpg' || documento.documento.substr(documento.documento.length - 3) == 'png' || documento.documento.substr(documento.documento.length - 4) == 'jpeg' || documento.documento.substr(documento.documento.length - 3) == 'bmp' || documento.documento.substr(documento.documento.length - 3) == 'gif' || documento.documento.substr(documento.documento.length - 4) == 'tiff' || documento.documento.substr(documento.documento.length - 4) == 'webp'">
                                                    <img style="width: 150px; height: 160px;" v-if="urlglobal != 'null.pwgs.app'"
                                                    :src='documento.url_completa_descarga' width="150" preview
                                                    :title="documento.descripcion" />
                                                    <img style="width: 150px; height: 160px;" v-else-if="urlglobal == 'null.pwgs.app'"
                                                        :src='"https://desarrollo.pwgs.app/" + documento.url_descarga' width="150"
                                                        preview :title="documento.descripcion" />
                                                </div>
                                                <div style="display: grid" v-else>
                                                    <i class="fas fa-file-pdf" style="font-size:160px;"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>
                        </div>
                        <br v-if="Object.keys(campo) == 'documentos'">
                        <FileUpload v-if="Object.keys(campo) == 'documentos'" ref="fileupuno" mode="advanced"
                            :showUploadButton="false" :maxFileSize="20000000" @select="subirarchivos($event)"
                            multiple="true" chooseLabel="Subir Archivos" />
                        <br v-if="archivossubido.length > 0 && Object.keys(campo) == 'documentos'">
                        <select v-if="archivossubido.length > 0 && Object.keys(campo) == 'documentos'" :class="'custom-select form-control '"
                            v-model="tipodocumentoseleccionado" style="width: fit-content; height: 30px;">
                            <option v-for="tiposdoc in tiposdocumento" :key="tiposdoc.valor" :value="tiposdoc.valor"   >
                                {{tiposdoc.texto}}</option>
                        </select>



                        <!--FIN SECCION DOCUMENTOS-->

                    </div><!--FIN CAMPOS-->
                    <ul style="list-style-type: none;">
                        <li v-for="documento in documentosanyadidos" :key="documento.id_documento">
                            <p><button @click="eliminardocumento(documento)"
                                    class="p-button p-component p-button p-component p-button-icon-only p-button-danger p-button-rounded p-button-text"
                                    type="button" aria-label="Cancel" data-pc-name="button" data-pc-severity="danger"
                                    data-pc-section="root"><span class="p-button-icon pi pi-times"
                                        data-pc-section="icon"></span></button>{{
                                documento.documento }}&nbsp;({{
                                documento.valor }})</p>
                        </li>
                    </ul>
                    <div class="col-md-12">
                        <button class="btn btn-success btn-block" @click="enviarComunicacion()" type="button">{{
                            $t('general.enviar') }}</button>
                    </div>
                </div><!--FIN SECCION FORMULARIO-->
            </div><!--FIN SPINNER-->
        </div><!--FIN CARD BODY-->
    </div><!--FIN CARD-->
</template>
<script>
import Editor from 'primevue/editor';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import FileUpload from 'primevue/fileupload';
import { PwgsApi } from '../../../../../services/PwgsApi';
export default ({
    props: ['id','minimizarprop'],
    data() {
        return {
            direccionglobal: localStorage.getItem('direccion'),
            mostrarChatBot: false,
            chatbotUrl: '',
            idsdocsanyadidos:[],
            gremios: '',
            gremioseleccionado: '',
            comunicacionessistema: '',
            tiposenvio: '',
            tipoenvioseleccionado: '',
            nombretipoenvioseleccionado: '',
            keytipoenvioseleccionado: '',
            spinner: false,
            id_comunicacion: '',
            longitud: [],
            documentos: '',
            mostrardialogo: false,
            urlglobal: '',
            documentosanyadidos: [],
            archivossubido:[],
            tiposdocumento:'',
            tipodocumentoseleccionado: '', 
            documentossubidos:[],
                        repetiraux:0,



        }
    },

    components: {
        Editor, Dialog, Button,Calendar,FileUpload
    },
    methods: {

        vaciardatos() {
            this.gremios = '';
            this.gremioseleccionado = '';
            this.comunicacionessistema = '';
            this.tiposenvio = '';
            this.tipoenvioseleccionado = '';
            this.nombretipoenvioseleccionado = '';
            this.keytipoenvioseleccionado = '';


        },
        prueba123(cp) {
            for(let i=0;i<cp.length;i++){
                if (cp[i].documentos) {
                    if(cp[i].documentos[0].valores){
                        this.tiposdocumento=cp[i].documentos[0].valores
                    }
                }
            }
            console.log("campo", this.tiposdocumento);
        },
        subirarchivos(event) {
            for (let i = 0; i < event.files.length; i++) {
                this.archivossubido.push(event.files[i]);
            }
        },
        async uploadFile() {
            //POST  modulos/pwgsapi/index.php/servicios/:id/guardar-documento
            const formData = new FormData();
            formData.append("id_operario", 0);
            formData.append("id_visita", 0); this.mostrarplanning = true;
            formData.append("tipo_documento", 'ficherosvisitas');
            for (let i = 0; i < this.archivossubido.length; i++) {
                formData.append(this.archivossubido[i].name, this.archivossubido[i], this.archivossubido[i].name);
            }
            const api = new PwgsApi;
            try {
                this.documentossubidos =await api.post('servicios/' + this.$props.id + '/guardar-documento', formData);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Archivo subido correctamente', life: 2000 });
                this.$parent.$parent.cargardatos(this.$props.id, "cual", "si");
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
            this.archivossubido = [];
            console.log("fileupuno", this.$refs.fileupuno);
                for(let i = 0; i < this.$refs.fileupuno.length; i++){
                    this.$refs.fileupuno[i].clear();

                }
            
        },
        quitardocumentolista(doc){
            delete this.documentos[doc.id_documento];
        },
        async actualizarPrestacion(idipas, indice) {
            //index.php/servicios/:id/prestacion-ipas/:n_prestacion_ipas
            const api = new PwgsApi();
            if (confirm('¿Desea actualizar la prestación ' + idipas + '?')) {
                try {
                    await api.put('servicios/' + this.$props.id + '/prestacion-ipas/' + idipas);
                    this.cargarGremios(indice);
                }
                catch (e) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
                   
                }
               
            }

        },
        formatearDate(fecha) {
            let date = new Date(fecha);
            let day = date.getDate();
            let month = date.getMonth() + 1; // Add 1 because getMonth() returns 0-11
            let year = date.getFullYear();
            if (day < 10) {
                day = '0' + day;
            }
            if (month < 10) {
                month = '0' + month;
            }
            let formattedDate = `${day}/${month}/${year}`;
            if (isNaN(date)) {
                return fecha;
            }
            if (!isNaN(date)) {
                return formattedDate;

            }

        },
        async cargardocumentos() {
            this.urlglobal = localStorage.getItem('direccion');
            // GET:  modulos/pwgsapi/index.php/servicios/:id/documentos
            const api = new PwgsApi();
            try {
                var documentosaux = await api.get('servicios/' + this.$props.id + '/documentos');
                this.documentos = [];
                for(let documento of Object.values(documentosaux)){
                    if(documento.documento.substring(0, 15) != 'firma_operario_'){
                        var encontrado = '';
                        if(this.documentos.length == 0){
                            this.documentos.push({
                                idvisita: documento.visitadores_idvisitador,
                                fecha: documento.fecha_visita,
                                operario: documento.operario,
                                documentos: [documento]
                            });
                        }else{
                            encontrado = this.documentos.find(doc => doc.idvisita == documento.visitadores_idvisitador);                        
                            if(encontrado == undefined){
                                this.documentos.push({
                                    idvisita: documento.visitadores_idvisitador,
                                    fecha: documento.fecha_visita,
                                    operario: documento.operario,
                                    documentos: [documento]
                                });
                            }else{
                                encontrado.documentos.push(documento);
                            }
                        }
                    }
                        
                }
                console.log('documentos', this.documentos);
            }
            catch (e) {
                console.log(e);
                setTimeout(() => {
                    document.getElementsByClassName("defecto")[0].click();
                }, 500);
            }
            this.mostrardialogo = true;
        },
        asociardocumento(archivo) { /* Prepara los documentos seleccionados en un array para enviarlos*/
            this.documentosanyadidos.push(archivo);
            this.idsdocsanyadidos.push(archivo.id_documento);
        },
        eliminardocumento(doc) {/*Elimina el documento del array del envio*/
            this.documentosanyadidos.splice(this.documentosanyadidos.indexOf(doc), 1);
            this.idsdocsanyadidos.splice(this.idsdocsanyadidos.indexOf(doc.id_documento), 1);
        },
        async enviarComunicacion() {/* ENVIA LA COMUNICACION (boton enviar comunicacion)*/
            let subidadatos = {};
            this.keytipoenvioseleccionado = this.getKeyByValue(this.comunicacionessistema.tipos_mensajes, this.tipoenvioseleccionado);
            let aux = {};
            subidadatos['tipo_mensaje'] = this.keytipoenvioseleccionado;
            aux['id_gremio'] = this.gremioseleccionado;

            if (this.nombretipoenvioseleccionado == 'Responder Diálogo') {
                aux['id_comunicacion'] = this.id_comunicacion;
            }
            for (let i = 0; i < this.tipoenvioseleccionado.campos.length; i++) {
                if (this.tipoenvioseleccionado.campos[i].tipo == "date") {

                    if (this.tipoenvioseleccionado.campos[i].modificada == true) {
                        aux[this.tipoenvioseleccionado.campos[i].nombre] = this.formatearDate(this.tipoenvioseleccionado.campos[i].valor);
                    }
                    else {
                        aux[this.tipoenvioseleccionado.campos[i].nombre] = this.tipoenvioseleccionado.campos[i].valor;

                    }
                }
                else {
                    aux[this.tipoenvioseleccionado.campos[i].nombre] = this.tipoenvioseleccionado.campos[i].valor;
                }

            }
            /**AÑADIR DOCUMENTOS**/
            aux["documentos"] = [];

            if (this.archivossubido.length > 0) {
                await this.uploadFile();
                if (this.documentossubidos.length > 0){
                    for (let k = 0; k < this.documentossubidos.length; k++) {
                        aux["documentos"].push({
                            tipo_archivo: this.tipodocumentoseleccionado,
                            nombre_documento: this.documentossubidos[k].documento,
                        });
                    }

            }
               

            }
            if (this.documentosanyadidos.length > 0) {
                console.log("pruebadocumentos",this.documentosanyadidos);

                for (let j = 0; j < this.documentosanyadidos.length; j++) {
                    aux["documentos"].push({
                        tipo_archivo: this.documentosanyadidos[j].valor,
                        nombre_documento: this.documentosanyadidos[j].documento
                    });
                }
            }
            console.log("archivossubido",this.archivossubido);
            

            /**FIN AÑADIR DOCUMENTOS**/
            subidadatos["campos"] = aux;

            const api = new PwgsApi();
            try {
                await api.post('servicios/' + this.$props.id + '/comunicacion-sistema', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Enviada', detail: 'Comunicación enviada correctamente', life: 2000 });
                console.log("parentcomunicaciones", this.$parent);
                for (let i = 0;i<this.tipoenvioseleccionado.campos.length;i++){
                    if(this.tipoenvioseleccionado.campos[i].nombre == 'info'){
                        this.tipoenvioseleccionado.campos[i].valor = '';
                    }
                }
                this.archivossubido = [];
                this.documentosanyadidos = [];
                this.vaciardatos();
                this.cargarGremios();

                this.$parent.cargarmensajes();

            }

            catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });

            }

        },
        async comprobarCampoPendiente(actualizar) {/*Comprueba si al modificar el campo hay que actualizar los tipos de envio*/

            if (actualizar == 1) {

                let subidadatos = {};
                subidadatos['id_gremio'] = this.gremioseleccionado;
                subidadatos['tipo_mensaje'] = this.keytipoenvioseleccionado;

                if (this.nombretipoenvioseleccionado == 'Responder Diálogo') {/*Si el tipo de envio es responder_dialogo se envia la id de la comunicacion seleccionada*/
                    subidadatos['id_comunicacion'] = this.id_comunicacion;
                }

                for (let i = 0; i < this.tipoenvioseleccionado.campos.length; i++) {
                    if (this.tipoenvioseleccionado.campos[i].tipo == "date") {
                        if (this.tipoenvioseleccionado.campos[i].modificada == true) {
                            subidadatos[this.tipoenvioseleccionado.campos[i].nombre] = this.formatearDate(this.tipoenvioseleccionado.campos[i].valor);
                        }
                        else { 
                            subidadatos[this.tipoenvioseleccionado.campos[i].nombre] = this.tipoenvioseleccionado.campos[i].valor;

                        }

                    }
                    else {
                        subidadatos[this.tipoenvioseleccionado.campos[i].nombre] = this.tipoenvioseleccionado.campos[i].valor;
                    }  
                }
                const api = new PwgsApi();
                this.spinner = true;
                try {
                    this.comunicacionessistema = await api.post('servicios/' + this.$props.id + '/comunicaciones-sistema', subidadatos);
                    this.tiposenvio = this.comunicacionessistema.tipos_mensajes;
                    this.tipoenvioseleccionado = this.comunicacionessistema.tipos_mensajes[this.keytipoenvioseleccionado];
                }

                catch (e) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });


                }
                this.spinner = false;


            }

        },

        async cargarGremios(indice) {
            //GET  modulos/pwgsapi/index.php/servicios/:id/comunicaciones-gremios
            this.gremios = '';
            const api = new PwgsApi();
            try {
                this.gremios = await api.get('servicios/' + this.$props.id + '/comunicaciones-gremios');
                if (indice && indice != "defecto") {
                    document.getElementsByClassName('prestacion' + indice)[0].click();

                }
                else{
                setTimeout(() => {
                    document.getElementsByClassName("defecto")[0].click();
                }, 500);
                }
            }
            catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });


            }
        },
        async seleccionarGremio(valorgremio) {
            this.mostrarChatBot = false;
            //POST  modulos/pwgsapi/index.php/servicios/:id/comunicaciones-sistema
            this.spinner = true;
            this.tipoenvioseleccionado = '';
            this.gremioseleccionado = valorgremio;
            const api = new PwgsApi();
            try {

                this.comunicacionessistema = await api.post('servicios/' + this.$props.id + '/comunicaciones-sistema', { id_gremio: this.gremioseleccionado });
            } 

            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });

             }
            this.tiposenvio = this.comunicacionessistema.tipos_mensajes;
            this.tipoenvioseleccionado = this.comunicacionessistema.tipos_mensajes[this.comunicacionessistema.datos.envio_defecto];
            this.spinner = false;
        },
        cargarTipoenvio() { /* Al cambiar el tipo de envio*/
            this.nombretipoenvioseleccionado = this.tipoenvioseleccionado.nombre;
            this.keytipoenvioseleccionado = this.getKeyByValue(this.comunicacionessistema.tipos_mensajes, this.tipoenvioseleccionado);
            this.rellenarTipoEnvio();

        },
        async rellenarTipoEnvio() {
            this.spinner = true;
            this.mostrarChatBot = false;
            console.log("this.nombretipoenvioseleccionado", this.nombretipoenvioseleccionado);
            if(this.nombretipoenvioseleccionado == 'CHATBOT'){
                this.cargarChatbot(false);
            }else if(this.nombretipoenvioseleccionado == 'CHATBOT Historial'){
                this.cargarChatbot(true);
            }
            const api = new PwgsApi();
            try{
                this.comunicacionessistema = await api.post('servicios/' + this.$props.id + '/comunicaciones-sistema', { id_gremio: this.gremioseleccionado, tipo_mensaje: this.keytipoenvioseleccionado });
            }
            catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
                document.getElementsByClassName("defecto")[0].click();


            }
            this.tiposenvio = this.comunicacionessistema.tipos_mensajes;
            this.tipoenvioseleccionado = this.comunicacionessistema.tipos_mensajes[this.keytipoenvioseleccionado];
            this.spinner = false;
            if (this.nombretipoenvioseleccionado == 'Responder Diálogo') {
                document.getElementsByClassName("defectoresponderdialogo")[0].click();
            }

        },
        async cargarChatbot(historial) {            
            if(this.direccionglobal == 'null.pwgs.app'){
                this.direccionglobal = 'pwgs.raul.pwgs5.interno.apuyen.app'
            }
            if(historial){
                this.chatbotUrl = 'https://' + this.direccionglobal + `/modulos/ipas_ws/vistas/chatbot.php?historial=1&id_servicio=${this.id}&id_mensaje=${this.gremioseleccionado}`;
            }else{
                this.chatbotUrl = 'https://' + this.direccionglobal + `/modulos/ipas_ws/vistas/chatbot.php?id_servicio=${this.id}&id_mensaje=${this.gremioseleccionado}`;
            }
            this.mostrarChatBot = true
        },
        async cargarResponderDialogo() {
            this.spinner = true;
            const api = new PwgsApi();
            this.comunicacionessistema = await api.post('servicios/' + this.$props.id + '/comunicaciones-sistema', { id_gremio: this.gremioseleccionado, tipo_mensaje: this.keytipoenvioseleccionado, id_comunicacion: this.id_comunicacion });
            this.tiposenvio = this.comunicacionessistema.tipos_mensajes;
            this.tipoenvioseleccionado = this.comunicacionessistema.tipos_mensajes[this.keytipoenvioseleccionado];
            this.spinner = false;
        },
        getKeyByValue(object, value) {
            return Object.keys(object).find(key => object[key] === value);
        },
          minimizarpulsar(){
            if(this.repetiraux==0){
                            this.$parent.$parent.minimizar();
                            this.repetiraux=1;

            }
            setTimeout(() => {
                this.repetiraux=0;
            }, 500);
        },
        estilocampos(tipo, saltolinea,desc) {
            let auxlinea = 'display:inline-block;margin-bottom:15px'
            if (saltolinea == true) {
                auxlinea = "display:block;margin-bottom:10px"
            }
            if (tipo == "hidden") {
                return "margin-right:0px;visibility:hidden;" + auxlinea;
            }
            if (tipo == "textarea") {
                return "width:100%;display:inline-block;" + auxlinea

            }

            if (tipo == "text") {
                if (desc == "Descripción futura acción") {
                    return "width:100%;display:inline-block;margin-right:20px;" + auxlinea

                }
                return "display:inline-block;margin-right:20px;" + auxlinea

            }

            return "width:fit-content;margin-right:20px;" + auxlinea

        },
        onKeyDown(evt, texto, maximocaracteres) {
            if (maximocaracteres) {
                if (document.getElementById(texto).value.length >= maximocaracteres) {
                    if (evt.keyCode >= 48 && evt.keyCode <= 90) {
                        evt.preventDefault()
                        return
                    }
                }
            }
        },
        sacarlongitud(texto) {
            this.longitud[texto] = document.getElementById(texto).value.length;

        },
        sacarvalor(texto) {
            return document.getElementById(texto).value
        },
        decode_utf8(s) {
            try {
                return decodeURIComponent(escape(s));
            }
            catch (error) {
                console.log(error);
                return s;
            }
        },

    },

    mounted() {
        this.cargarGremios();

    },
    watch: {
        id() {
            this.vaciardatos();
            this.cargarGremios();

        },
        tipoenvioseleccionado() {

            this.documentosanyadidos = [];
            if (this.tipoenvioseleccionado && this.tipoenvioseleccionado.campos) {
                for (let i = 0; i < this.tipoenvioseleccionado.campos.length; i++) {
                    if (this.tipoenvioseleccionado.campos[i].nombre && this.tipoenvioseleccionado.campos[i].nombre.includes("fecha")) {

                        try { this.tipoenvioseleccionado.campos[i - 1].saltolinea = true; }
                        catch (error) {
                            console.log("error", error);
                         }

                    }
                }
                this.prueba123(this.tipoenvioseleccionado.campos);
            }


        }
    }
})






</script>
<style scoped>
.break {
    flex-basis: 100%;
    height: 0;
}

.flex-br {

    width: 100%;
    height: 0;

}

.difuminado {
    filter: blur(6px);
    pointer-events: none;
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
}

.difuminadodos {
    filter: blur(6px);
    pointer-events: none;
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
}

.spinners {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 9px solid;
    border-color: #d9e3ff;
    border-right-color: #007bff;
    animation: spinner-d3wgkg 1s infinite linear;
    position: absolute;
    z-index: 1000;
    top: 70% !important;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;

}

@keyframes spinner-d3wgkg {
    to {
        transform: rotate(1turn);
    }
}
</style>